<!-- back-to-top -->
<div id="back-to-top" style="display: none;">
  <a class="top" id="top" href="javascript:void(0)" (click)="scrollTop()"> <i class="ion-ios-arrow-up"></i> </a>
</div>
<!-- back-to-top End -->
